





































import { Component, Vue } from 'vue-property-decorator';
import InNeedOfActionCard from '@/components/InNeedOfActionCard.vue';
import Form from '@/classes/Form';
import UserNotification from '@/classes/UserNotification';

@Component({
    components: {
        InNeedOfActionCard
    }
})
export default class Home extends Vue {
    public sendTo(destination: string): void {
        this.$router.push(destination);
    }

    public created() {
        this.$store.dispatch('loadCertificateForms', true);
        this.$store.dispatch('material/loadMaterialForms', true);
        this.$store.dispatch('loadUserProfiles');
        this.$store.dispatch('injury/loadInjuryForms', true);
    }

    get actionableForms(): Form[] {
        return this.$store.getters.getFormsInNeedOfAction || [];
    }

    private gotoHelp(): void {
        window.open('/help', '_blank');
    }

    private get userNotifications(): UserNotification[] {
        return this.$store.getters['notifications/getViewableUserNotifications'] || [];
    }
}
